import { useMutation } from '@tanstack/react-query';
import {
  validateAuthCode,
  type ValidateAuthCodeParams,
} from 'shared/src/api/myPageService/phoneAuthPoc/validateAuthCode/validateAuthCode';

export const useValidateAuthCode = () => {
  return useMutation({
    mutationFn: (params: ValidateAuthCodeParams) => validateAuthCode(params),
    throwOnError: false,
  });
};
